import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import * as parentActions from '@app/actions/parents'
import _ from 'lodash'

export function normalizeProps(Component) {
  class PropsNormalizer extends React.Component {
    render() {
      const {forwardedRef, students, ...rest} = this.props;
      let children = _.map(_.values(students.objects), 'object')

      return (
        <Component
          ref={forwardedRef}
          students={children}
          originalStudents={students}
          {...rest}
        />
      )
    }
  }

  return React.forwardRef((props, ref) => {
    return <PropsNormalizer {...props} forwardedRef={ref} />;
  });
}

class Retriever extends Component {
  componentDidMount() {
    this.props.boundActions.fetchChildrenIfNeeded()
  }

  addLearner(payload) {
    return this.boundActions.addLearner(this.props.classId, payload)
  }

  updateLearner(payload) {
    return this.boundActions.updateLearner(this.props.classId, payload)
  }

  deleteLearner(id) {
    return this.boundActions.deleteLearner(this.props.classId, id)
  }

  render() {
    const { ChildComponent, ...rest } = this.props
    return (<ChildComponent {...rest} />)
  }
}

const mapStateToProps = (state) => {
  const { global, parents: { children, child } } = state;
  return { global, students: children, student: child }
}

const mapDispatchToProps = (dispatch) => {
  let boundActions = bindActionCreators(parentActions, dispatch)
  return { boundActions }
}

Retriever.propTypes = {
  ChildComponent: PropTypes.any.isRequired
}

export default connect(mapStateToProps, mapDispatchToProps)(Retriever)
